<template>
  <span @click="seleccionar()">
    <v-tooltip bottom >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          :loading="loading"
        >
          <v-icon :color="color" left> mdi-check-bold </v-icon>
        </v-btn>
      </template>
        <span>{{ tooltip ? $utilidades.traduccion({ texto: tooltip }) : $utilidades.traduccion({ texto: text }) }}</span>
    </v-tooltip>

  </span>
</template>

<script>
export default {
  name: "BtnSeleccionar",
  props: {
    rounded: Boolean,
    text: {
      type: String,
      default: "Seleccionar",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showOnlyIcon: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "info",
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
  components: {},
  methods: {
    seleccionar() {
      this.$emit("seleccionar");
    },
  },
};
</script>